import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { AuthSevices, ClaimService, ClientService, CommonService } from '../../../../../api/src';
import { BehaviorSubject, Observable } from 'rxjs';
import { Claim, ClientCreditBalance, ClientCreditBalanceListResponse, Refund, RefundData, RefundType, TENANTSINTERFACE } from '../../../../../models/src';
import { Store } from '@ngrx/store';
import { UntypedFormBuilder } from '@angular/forms';
import { environment } from '../../../../../../apps/ff-frontend/src/environments/environment';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { RippleModule } from 'primeng/ripple';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { ProcessRefundComponent } from '@fitness-force/refund';

@Component({
  selector: 'client-credit-balance',
  templateUrl: './client-credit-balance.component.html',
  styleUrls: ['./client-credit-balance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [    CommonModule,
    DialogModule,
    TableModule,
    ButtonModule,
    PopoverModule,
    RippleModule,
    CurrencyformatPipe,
    ProcessRefundComponent,
    TranslateModule],
})
export class ClientCreditBalanceComponent implements OnInit {
  @Input('visible') showCreditBalance: boolean = false;
  @Input('clientId') clientId: number = 0;
  @Output() closePopup = new EventEmitter();

  claims: string[] = ['can_do_billing'];
  claim$: Observable<Claim[]> = new Observable();
  clientCreditBalance$ = new BehaviorSubject<ClientCreditBalance[]>([]);
  allTenants: any;
  currentUserDetails: any;
  showRefund  = new BehaviorSubject<boolean>(false);
  refundData:RefundData= {} as RefundData;
  loadTable: Boolean= true;
  
  constructor( private store: Store,
    public translate: TranslateService,
    private clientService: ClientService,
    private fb: UntypedFormBuilder,
    private claimService: ClaimService,
    private commonService:CommonService,
    private authService: AuthSevices
    ) { }

  ngOnInit(): void {
    this.loadTable=true;
    this.claim$ = this.claimService.GetClaim(environment.BASE_URL);
    this.currentUserDetails = this.authService.decodedToken;
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.allTenants= tenant.all_tenant;
    });
    this.clientService.getClientCreditBalanceList(this.clientId).subscribe({
      next: (res:ClientCreditBalanceListResponse) => {
        this.clientCreditBalance$.next(res.items ? res.items : []);
        this.loadTable=false;
      },
      error: (error: any) => {
        this.clientCreditBalance$.next([]);
        this.loadTable=false;
      }
    });
  }

  getTenant(tenantId:number)
  {
    return this.allTenants.find((o: { id: number; }) => o.id == tenantId)!;
  }

  ProcessRefund(balance:ClientCreditBalance)
  {
      this.refundData.amount = balance.available_credit_balance;
      this.refundData.tenantId = balance.tenant_id;
      this.refundData.refundType = RefundType.CreditBalance;
      this.refundData.clientId= this.clientId;
      this.refundData.primaryId=0;
      this.refundData.isOnline= false;
      this.refundData.paymentGateway= null;
      this.showRefund.next(true);      
  }

  closeRefundDialogEvent(event:any)
  {
    this.showRefund.next(false);
    if(event.reloadData)
    {
      this.clientService.getClientCreditBalanceList(this.clientId).subscribe({
        next: (res:ClientCreditBalanceListResponse) => {
          this.clientCreditBalance$.next(res.items ? res.items : []);
        },
        error: (error: any) => {
          this.clientCreditBalance$.next([]);
        }
      });
    }
    this.closeCreditPopup(event.reloadData);
  }

  closeCreditPopup(update:boolean)
  {
    this.showCreditBalance=false;
    this.closePopup.emit(update ? { action: "updated" } : update);
  }
  

  get hasAdminBilling(): boolean {
    return this.currentUserDetails.can_admin_billing == 'true' ? true : false;
  }

}